"use client";

import { HomePage } from "./pages/HomePage";
import { WebchatPage } from "./pages/WebchatPage";
import { Pages, useWebchatStore } from "./store";
import { cn } from "@deputy-ai/common";
import { Transition } from "@headlessui/react";

const WEBCHAT_PANEL_STYLES = cn(
  "webchat-panel absolute top-0 bottom-0 w-full bg-white transition ease-in-out",
  "data-closed:opacity-0",
  "data-enter:duration-200 data-enter:data-closed:translate-x-full",
  "data-leave:duration-200 data-leave:data-closed:translate-x-full"
);

const TRANSITION_CONFIG = {
  show: false,
  appear: true,
  unmount: false,
} as const;

export function Page() {
  const {
    use: { page },
  } = useWebchatStore();

  const isChatPageVisible = page === Pages.CHAT;

  return (
    <div className="relative h-full grow flex-row">
      <HomePage />
      <Transition {...TRANSITION_CONFIG} show={isChatPageVisible}>
        <div className={WEBCHAT_PANEL_STYLES}>
          <WebchatPage />
        </div>
      </Transition>
    </div>
  );
}
